import { Box, Typography } from '@mui/material';
import { asImageSrc, Content } from '@prismicio/client';
import { PrismicText } from '@prismicio/react';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import Link from 'components/@common/Link';

interface Props {
  promotion: Content.PromotionsDocument;
}

const PromotionCard: React.FC<Props> = ({ promotion }) => {
  const { thumbnail, name } = promotion.data;

  return (
    <Box bgcolor="support.neutral01" p={6} borderRadius="10px">
      {thumbnail.url && (
        <Box
          borderRadius={2}
          mb={4}
          position="relative"
          height="auto"
          overflow="hidden"
          pb={`${
            (thumbnail.dimensions.height / thumbnail.dimensions.width) * 100
          }%`}
        >
          <Image
            alt={thumbnail.alt ?? ''}
            src={asImageSrc(thumbnail)}
            fill
            style={{ objectFit: 'cover', borderRadius: 8 }}
          />
        </Box>
      )}
      <Typography variant="h4" mb={2}>
        {name}
      </Typography>
      <Typography mb={4}>
        <PrismicText field={promotion.data.description} />{' '}
        <Link
          href={{
            pathname: Routes.PromotionDetail,
            query: { slug: promotion.uid },
          }}
        >
          <FormattedMessage id="label.show_more" />
        </Link>
      </Typography>
    </Box>
  );
};

export default PromotionCard;
